import React, { useEffect } from "react";
import Demo from "./MSN Popups/newDemo";
import Demo2 from "./MSN Popups/newDemo2";
import Demo3 from "./MSN Popups/newDemo3";
import Demo4 from "./MSN Popups/newDemo4";
import { Link } from "react-router-dom";
import { randNotif, randTask, randGroup, randDelay, UNLVDate } from "../utils";
import Button from "@material-ui/core/Button";
import firebase from "./page/firebaseConfig";

export default function AfterTask(props) {
    // state controlling when MSN opens and when user can continue
    const [openTask, setOpenTask] = React.useState(false);
    const [enableContinue, setEnableContinue] = React.useState(true); 
    
    // Determine which msn we should render
    var MSN;
    if(randNotif === 1) {
        MSN = <Demo />;
    } else if (randNotif === 2) {
        MSN = <Demo2 />;
    } else if (randNotif === 3) {
        MSN = <Demo3 />;
    } else {
        MSN = <Demo4 />;
    }

    // After 5 seconds, open the msn and enable continue button
    useEffect(() => {
        setTimeout(() => {
            setOpenTask(true);
            setEnableContinue(false);
            document.getElementById("wait").innerHTML = "Press continue to proceed to next page!"
        }, 5000);
    }, []);
    function toFirebase() {
      var score;
      if(randTask === 1) {
        score = localStorage.getItem("score")
      } else if(randTask === 2) {
        score = localStorage.getItem("task_score");
      }
      const db = firebase.firestore();
            db.collection("login_handler")
              .doc(localStorage.getItem("user_id"))
              .collection("AprilGroup1")
              .add({
                worker_id: localStorage.getItem("user_id"),
                unique_id: localStorage.getItem("unique_id"),
                group: randGroup,
                threat: localStorage.getItem("threat"),
                efficacy: localStorage.getItem("efficacy"),
                task_time_DTI: localStorage.getItem("task_time"),
                task_type: localStorage.getItem("task_type"),
                start_time: localStorage.getItem("home_icon_click_time"),
                time_end: UNLVDate(),
                time_MSN_display: localStorage.getItem("msn_start_time"),
                time_respond: localStorage.getItem("time_respond"),
                MSN_accept: localStorage.getItem("msn_accept"),
                security_setting: localStorage.getItem("security_setting"),
                time_setting: localStorage.getItem("setting_change_time"),
                performance_score: parseInt(score),
              })
              .then(function (docRef) {
                console.log("Document written with ID: ", docRef.id);
              })
              .catch(function (error) {
                console.error("Error adding document: ", error);
              });
    }

    return (
        <div>
            <br></br>
            {/*When openTask state is true, open MSN*/}
            { openTask ? MSN : <></> }
            <h1
              style={{margin: "auto", width: "80%"}}>
                Redirecting to rest of platform...
            </h1>
            <br></br>
            <p
              id = "wait"
              style={{margin: "auto", width: "80%"}}>
                Please wait...
            </p>
            <br></br>
            <div
              style={{margin: "auto", width: "80%", paddingTop: 20}}>
                <Button
                style={{ textTransform: "none" }} 
                variant="contained" size="small" 
                color="primary"
                disabled={enableContinue}
                >
                    <Link 
                    to={"/post_survey"}
                    style={{ color: "white" }}
                    onClick={toFirebase}>
                    Continue
                    </Link>
                </Button>
            </div>
        </div>
    );
}